"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const labelButton_1 = __importDefault(require("../../components/labelButton/labelButton"));
const utils_1 = require("../../utils/utils");
const authSlice_1 = require("./authSlice");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../../components/text/textStyles"));
const homeSlice_1 = require("../home/homeSlice");
const analytics_1 = require("../../utils/analytics/analytics");
const RecoverPassword = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [email, setEmail] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        dispatch((0, authSlice_1.resetAuthSlice)());
    }, []);
    const performRecoverPassword = async () => {
        setIsLoading(true);
        const payload = { email: email ? email.toString() : '' };
        const result = await dispatch((0, authSlice_1.recoverPassword)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'recover_password',
            status: 'submitted',
            location: 'screen_RecoverPassword',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'recover_password',
                status: 'success',
                location: 'screen_RecoverPassword',
            });
            dispatch((0, homeSlice_1.addMessages)([
                {
                    title: 'Check Your Mail',
                    message: 'We sent a reset password email to you. Please go to your email and use it to reset your password.',
                    iconSize: 55,
                },
            ]));
            dispatch((0, homeSlice_1.showMessage)());
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'recover_password',
                status: 'fail',
                location: 'screen_RecoverPassword',
            });
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(navContainer_1.default, { isLoading: isLoading, errors: errors, withLogo: true, titleText: "Forgot Password", subTitleText: "We will send you an email so you can change your password" },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Email", placeholder: "Email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: email }),
        react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Recover password", onPress: performRecoverPassword, eventName: "recover_password" }),
        react_1.default.createElement(labelButton_1.default, { title: "Login", onPress: () => navigation.replace(screenConstants_1.SIGN_IN_SCREEN), disabled: false, textColor: theme_1.default.colors.COLOR_PRIMARY, eventName: "navigate_login", textBeforeLink: "Already have an account? ", positionStyle: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexDirectionRow], linkStyle: textStyles_1.default.underline })));
};
exports.default = RecoverPassword;
